unit unit_Dateien;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.Buttons, Vcl.Controls, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.ExtCtrls, Data.DB, XData.Web.JsonDataset, strutils,
  XData.Web.Dataset, WEBLib.Grids, WEBLib.DBCtrls, WEBLib.DB, WEBLib.WebCtrls,
  XData.Web.Client;

type
  TfrmDateien = class(TForm)
    dsDateien: TXDataWebDataSet;
    sourceDateien: TDataSource;
    Container1: THTMLContainer;
    Container2: THTMLContainer;
    Container3: THTMLContainer;
    btnzurueck: TButton;
    dsDateienID: TIntegerField;
    dsDateienDatumUhrzeit: TDateTimeField;
    dsDateienDateiMime: TStringField;
    dsDateienDateiName: TStringField;
    dsDateienDateiGroesse: TIntegerField;
    dsDateienDateiInhaltThumb: TStringField;
    dsDateienProtokoll: TStringField;
    dsDateienDateiBetreff: TStringField;
    dsDateienKundennummer: TStringField;
    dsDateienNummerkomplett: TStringField;
    dsDateienObjektReferenz: TStringField;
    dsDateienFahrzeugID: TIntegerField;
    btnNeu: TButton;
    btnFoto: TButton;
    WClient: TXDataWebClient;
    MSGLOESCHEN: TMessageDlg;
    xdsProtokolleLoeschungen: TXDataWebDataSet;
    xdsProtokolleLoeschungenID: TStringField;
    xdsProtokolleLoeschungenDatum: TDateTimeField;
    xdsProtokolleLoeschungenBenutzer: TStringField;
    xdsProtokolleLoeschungenBelegart: TStringField;
    xdsProtokolleLoeschungenBelegnummer: TStringField;
    xdsProtokolleLoeschungenProtokoll: TStringField;
    dsDateienAuslagerungsdatei: TStringField;
    WebImageControl1: TImageControl;
    procedure WebFormShow(Sender: TObject);
    procedure dsDateienAfterOpen(DataSet: TDataSet);
    procedure btnzurueckClick(Sender: TObject);
    procedure btnNeuClick(Sender: TObject);
    procedure btnFotoClick(Sender: TObject);
    procedure dsDateienAfterDelete(DataSet: TDataSet);
    procedure dsDateienAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure dsDateienBeforeDelete(DataSet: TDataSet);
    procedure xdsProtokolleLoeschungenAfterPost(DataSet: TDataSet);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    MerkerArt:string;
    MerkerNummerkomplett:string;
    MerkerObjektreferenz:string;
    MerkerFahrzeugID:string;
    MerkerKundennummer:string;
    MerkerName:string;
    HeadlineText:string;
    EinzelCard:THTMLDiv;
    btnDateiLoeschen:TButton;
    ThumbCtrl:TImageControl;
    procedure EinzelCardclick(Sender:TObject);
    procedure openeinzeldateiform(id:string);
    [async] procedure btnDateiLoeschenClick(Sender:TObject); async;
  protected procedure LoadDFMValues; override; end;

var
  frmDateien: TfrmDateien;

implementation
  uses unit1, unit2, unit_GetPhoto, unit_Einzeldatei;
{$R *.dfm}

procedure TfrmDateien.btnDateiLoeschenClick(Sender: TObject);

  //myPositionsID:=inttostr((sender as TWebButton).tag);
  //myArtikelnummer:=(sender as TWebButton).Hint;
var
  mr: TModalResult;
  myEinzeldateiID:string;
  myEinzeldateiName:string;
begin
  myEinzeldateiID:=inttostr((sender as TButton).Tag);
  myEinzeldateiName:=(sender as TButton).Hint;
  if dsdateien.Locate('Id',myeinzeldateiid,[])=true then
  begin
    mr := await(TModalResult, Msgloeschen.ShowDialog('Das Löschen einer Datei kann nicht rückgängig gemacht werden. Wollen Sie die Datei "'+myEinzeldateiName+'" wirklich löschen?', WEBLib.Dialogs.mtConfirmation,[mbYes, mbNo]));
    if mr = mrYes then dsdateien.Delete;
  end;
end;

procedure TfrmDateien.btnFotoClick(Sender: TObject);
var
  LFrm:TGetPhoto;
  myEinzeldateiID:string;
begin
  myEinzeldateiID:='';
  Container3.HTML.text:='';
  GetPhoto := TGetPhoto.CreateNew(procedure(AForm: TObject)
    begin
      (AForm as TGetPhoto).PhotoFunktion:='Foto';
      (AForm as TGetPhoto).PhotoMerkerNummerkomplett:=MerkerNummerkomplett;
      (AForm as TGetPhoto).PhotoMerkerObjektreferenz:=MerkerObjektreferenz;
      (AForm as TGetPhoto).PhotoMerkerFahrzeugID:=MerkerFahrzeugID;
      (AForm as TGetPhoto).PhotoMerkerKundennummer:=MerkerKundennummer;
    end
    );

  GetPhoto.ShowModal(procedure(AValue: TModalResult)
    begin
      dsDateien.close;
      dsDateien.Load;
    end
    );
end;

procedure TfrmDateien.btnNeuClick(Sender: TObject);
var
  LFrm:TGetPhoto;
  myEinzeldateiID:string;
begin
  myEinzeldateiID:='';
  Container3.HTML.text:='';
  GetPhoto := TGetPhoto.CreateNew(procedure(AForm: TObject)
    begin
      (AForm as TGetPhoto).PhotoFunktion:='Datei';
      (AForm as TGetPhoto).PhotoMerkerNummerkomplett:=MerkerNummerkomplett;
      (AForm as TGetPhoto).PhotoMerkerObjektreferenz:=MerkerObjektreferenz;
      (AForm as TGetPhoto).PhotoMerkerFahrzeugID:=MerkerFahrzeugID;
      (AForm as TGetPhoto).PhotoMerkerKundennummer:=MerkerKundennummer;
    end
    );

  GetPhoto.ShowModal(procedure(AValue: TModalResult)
    begin
      dsDateien.close;
      dsDateien.Load;
    end
    );

end;

procedure TfrmDateien.btnzurueckClick(Sender: TObject);
begin
  dsDateien.Close;
  self.close;
end;


procedure TfrmDateien.EinzelCardclick(Sender:TObject);
  procedure OnResponse(Response:TXDataClientResponse);
  var
    mydownload:string;
  begin
    mydownload:=string(TJSObject(response.Result)['value']);
    if mydownload='WRONG' then
    begin
      showmessage('Download kann nicht bereitgestellt werden');
    end
    else
    begin
      application.Navigate(downloadconnection+mydownload,ntblank);
    end;
  end;
var
  myEinzeldateiID:string;
begin
  myEinzeldateiID:=(sender as THTMLDiv).ElementID;
  dsdateien.Locate('Id',myeinzeldateiid,[]);
  if dsDateienAuslagerungsdatei.asstring='' then
  begin
    if lowercase(extractfileext(dsDateienDateiName.AsString))='.pdf' then
    begin
      WClient.RawInvoke('IServerService.GetDateiFromDokument',[myEinzeldateiID],@OnResponse);
    end
    else
    begin
      if lowercase(extractfileext(dsDateienDateiName.AsString))='.zip' then
      begin
        WClient.RawInvoke('IServerService.GetDateiFromDokument',[myEinzeldateiID],@OnResponse);
      end
      else
      begin
        openeinzeldateiform(myEinzeldateiID);
      end;
    end;
  end;
  if dsDateienAuslagerungsdatei.asstring<>'' then
  begin
     // wemm bereits ausgelagert
     WClient.RawInvoke('IServerService.GetDateiFromAusgelagert',[myEinzeldateiID],@OnResponse);
  end;
end;

procedure TfrmDateien.openeinzeldateiform(id:string);
var
  LFrm:TEinzelDatei;
  myEinzeldateiID:string;
begin
  myEinzeldateiID:=id;
  Container3.HTML.text:='';
  EinzelDatei := TEinzelDatei.CreateNew(procedure(AForm: TObject)
    begin
      (AForm as TEinzelDatei).EinzelDateiID:=myEinzeldateiID;
      (AForm as TEinzelDatei).Funktion:='Anzeige';
    end
    );

  Einzeldatei.ShowModal(procedure(AValue: TModalResult)
    begin
      dsDateien.close;
      dsDateien.Load;
    end
    );

end;

procedure TfrmDateien.dsDateienAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
begin
  self.close;
end;

procedure TfrmDateien.dsDateienAfterDelete(DataSet: TDataSet);
begin
  dsDateien.ApplyUpdates;
end;

procedure TfrmDateien.dsDateienAfterOpen(DataSet: TDataSet);
var
  myelement:TJSHTMLElement;
  EinzelKarte:string;
  MyFileExt:string;
begin
  Container1.html.text:='<nav class="navbar m-1 rounded bg-info"><h5>'+HeadlineText+'</h5></nav>';
  myelement:=Container1.ElementHandle;
  btnzurueck.ParentElement:=myelement;
  btnneu.ParentElement:=myelement;
  btnFoto.ParentElement:=myelement;
  Container2.HTML.Text:='';
  myelement:=container2.ElementHandle;

  while not dsDateien.eof do
  begin

    Einzelkarte:='<div class="card-header"><h5>'+dsDateienDateiBetreff.AsString+'</h5></div>';
    Einzelkarte:=Einzelkarte+'<div class="card-body"><i>Datei: </i><b>'+trim(dsDateienDateiname.AsString)+'</b>';
    Einzelkarte:=Einzelkarte+'<br><i>vom: </i><b>'+formatdatetime('DD.MM.YY hh:mm',dsdateienDatumUhrzeit.Asdatetime)+'</b>';
    Einzelkarte:=Einzelkarte+'<br><i>Kunde: </i><b>'+dsDateienKundennummer.AsString+' '+merkername+'</b>';
    Einzelkarte:=Einzelkarte+'<br><i>Objekt: </i><b>'+dsDateienObjektReferenz.AsString+'</b>';
    Einzelkarte:=Einzelkarte+'<br><i>'+Merkerart+': </i><b>'+dsDateienNummerkomplett.AsString+'</b>';
    Einzelkarte:=Einzelkarte+'</div>';
    if dsDateienAuslagerungsdatei.asstring<>'' then
    begin
      Einzelkarte:=Einzelkarte+'<div class="card-footer"><i>ausgelagert: </i>'+trim(dsDateienAuslagerungsdatei.AsString)+'<a/div>';
    end;


    myelement:=Container3.ElementHandle;
    EinzelCard:=THTMLDiv.Create(self);
    EinzelCard.ElementID:=dsDateienID.asstring;
    EinzelCard.HeightStyle:=ssauto;
    EinzelCard.Width:=400;
    EinzelCard.HTML.Text:=Einzelkarte;
    EinzelCard.ElementClassName:='card m-1 border-info';
    EinzelCard.OnClick:=@EinzelCardClick;
    EinzelCard.ParentElement:=myelement;
    MyFileExt:=lowercase(extractfileext(dsDateienDateiName.AsString));
    if (MyFileExt='.pdf') OR (MyFileExt='.zip') then
    begin
      myelement:=Einzelcard.ElementHandle;
      btnDateiLoeschen:=TButton.Create(self);
      btnDateiLoeschen.ElementClassName:='btn btn-info m-1 btn-sm text-left';
      btnDateiLoeschen.HeightStyle:=ssauto;
      btnDateiLoeschen.WidthStyle:=ssauto;
      btnDateiLoeschen.TabStop:=false;
      btnDateiLoeschen.tag:=dsDateienID.asinteger;
      btnDateiLoeschen.Hint:=trim(dsDateienDateiname.AsString);
      btnDateiLoeschen.Caption:='Datei löschen';
      btnDateiLoeschen.ElementPosition:=epIgnore;
      btnDateiLoeschen.OnClick:=@btnDateiLoeschenClick;
      btnDateiLoeschen.ParentElement:=myelement;
    end;
    if dsDateienDateiInhaltThumb.asstring<>'' then
    begin
      myelement:=Einzelcard.ElementHandle;
      thumbctrl:=TImageControl.create(self);
      thumbctrl.ElementPosition:=epignore;
      thumbctrl.ElementClassName:='img-fluid m-1 max-width: 100%';
      thumbctrl.HeightStyle:=ssauto;
      thumbctrl.url:=dsDateienDateiInhaltThumb.asstring;
      thumbctrl.ParentElement:=myelement;
    end;
    dsDateien.Next;
  end;

end;

procedure TfrmDateien.dsDateienBeforeDelete(DataSet: TDataSet);
var
  guid:TGUID;
  guidstring:string;
begin
  createguid(guid);
  guidstring:=guidtostring(guid);
  guidstring:=ReplaceStr(guidstring,'{','');
  guidstring:=ReplaceStr(guidstring,'}','');
  xdsProtokolleLoeschungen.Append;
  xdsProtokolleLoeschungenID.asstring:=guidstring;
  xdsProtokolleLoeschungenDatum.AsDateTime:=date+time;
  xdsProtokolleLoeschungenBenutzer.AsString:=BenutzerSchreibzeichen;
  xdsProtokolleLoeschungenBelegart.AsString:='Datei via CadiaWeb';
  xdsProtokolleLoeschungenBelegnummer.AsString:=dsDateienID.AsString;
  xdsProtokolleLoeschungenProtokoll.AsString:=dsDateienDateiName.AsString;
  xdsProtokolleLoeschungen.Post;
end;

procedure TfrmDateien.WebFormShow(Sender: TObject);
var
  myselect:string;
begin
  xdsProtokolleLoeschungen.Load;
  myselect:='$select=ID,DatumUhrzeit,DateiMime,DateiName,DateiGroesse,DateiInhaltThumb,DateiBetreff,Kundennummer,Nummerkomplett,ObjektReferenz,FahrzeugID,Auslagerungsdatei';
  dsDateien.Close;
  if MerkerArt='Auftrag' then dsDateien.QueryString:=myselect+'&$filter=contains(Nummerkomplett, '+QuotedStr(MerkerNummerkomplett)+')';
  if MerkerArt='Angebot' then dsDateien.QueryString:=myselect+'&$filter=contains(Nummerkomplett, '+QuotedStr(MerkerNummerkomplett)+')';
  if MerkerArt='Kontakt' then dsDateien.QueryString:=myselect+'&$filter=contains(Kundennummer, '+QuotedStr(MerkerKundennummer)+')';
  if MerkerArt='Objekt' then dsDateien.QueryString:=myselect+'&$filter=contains(Objektreferenz, '+QuotedStr(MerkerObjektreferenz)+')';
  dsDateien.Load;
end;

procedure TfrmDateien.xdsProtokolleLoeschungenAfterPost(DataSet: TDataSet);
begin
  xdsProtokolleLoeschungen.ApplyUpdates;
end;

procedure TfrmDateien.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebImageControl1 := TImageControl.Create(Self);
  Container1 := THTMLContainer.Create(Self);
  Container2 := THTMLContainer.Create(Self);
  Container3 := THTMLContainer.Create(Self);
  btnzurueck := TButton.Create(Self);
  btnNeu := TButton.Create(Self);
  btnFoto := TButton.Create(Self);
  MSGLOESCHEN := TMessageDlg.Create(Self);
  dsDateien := TXDataWebDataSet.Create(Self);
  dsDateienID := TIntegerField.Create(Self);
  dsDateienDatumUhrzeit := TDateTimeField.Create(Self);
  dsDateienDateiMime := TStringField.Create(Self);
  dsDateienDateiName := TStringField.Create(Self);
  dsDateienDateiGroesse := TIntegerField.Create(Self);
  dsDateienDateiInhaltThumb := TStringField.Create(Self);
  dsDateienProtokoll := TStringField.Create(Self);
  dsDateienDateiBetreff := TStringField.Create(Self);
  dsDateienKundennummer := TStringField.Create(Self);
  dsDateienNummerkomplett := TStringField.Create(Self);
  dsDateienObjektReferenz := TStringField.Create(Self);
  dsDateienFahrzeugID := TIntegerField.Create(Self);
  dsDateienAuslagerungsdatei := TStringField.Create(Self);
  sourceDateien := TDataSource.Create(Self);
  WClient := TXDataWebClient.Create(Self);
  xdsProtokolleLoeschungen := TXDataWebDataSet.Create(Self);
  xdsProtokolleLoeschungenID := TStringField.Create(Self);
  xdsProtokolleLoeschungenDatum := TDateTimeField.Create(Self);
  xdsProtokolleLoeschungenBenutzer := TStringField.Create(Self);
  xdsProtokolleLoeschungenBelegart := TStringField.Create(Self);
  xdsProtokolleLoeschungenBelegnummer := TStringField.Create(Self);
  xdsProtokolleLoeschungenProtokoll := TStringField.Create(Self);

  WebImageControl1.BeforeLoadDFMValues;
  Container1.BeforeLoadDFMValues;
  Container2.BeforeLoadDFMValues;
  Container3.BeforeLoadDFMValues;
  btnzurueck.BeforeLoadDFMValues;
  btnNeu.BeforeLoadDFMValues;
  btnFoto.BeforeLoadDFMValues;
  MSGLOESCHEN.BeforeLoadDFMValues;
  dsDateien.BeforeLoadDFMValues;
  dsDateienID.BeforeLoadDFMValues;
  dsDateienDatumUhrzeit.BeforeLoadDFMValues;
  dsDateienDateiMime.BeforeLoadDFMValues;
  dsDateienDateiName.BeforeLoadDFMValues;
  dsDateienDateiGroesse.BeforeLoadDFMValues;
  dsDateienDateiInhaltThumb.BeforeLoadDFMValues;
  dsDateienProtokoll.BeforeLoadDFMValues;
  dsDateienDateiBetreff.BeforeLoadDFMValues;
  dsDateienKundennummer.BeforeLoadDFMValues;
  dsDateienNummerkomplett.BeforeLoadDFMValues;
  dsDateienObjektReferenz.BeforeLoadDFMValues;
  dsDateienFahrzeugID.BeforeLoadDFMValues;
  dsDateienAuslagerungsdatei.BeforeLoadDFMValues;
  sourceDateien.BeforeLoadDFMValues;
  WClient.BeforeLoadDFMValues;
  xdsProtokolleLoeschungen.BeforeLoadDFMValues;
  xdsProtokolleLoeschungenID.BeforeLoadDFMValues;
  xdsProtokolleLoeschungenDatum.BeforeLoadDFMValues;
  xdsProtokolleLoeschungenBenutzer.BeforeLoadDFMValues;
  xdsProtokolleLoeschungenBelegart.BeforeLoadDFMValues;
  xdsProtokolleLoeschungenBelegnummer.BeforeLoadDFMValues;
  xdsProtokolleLoeschungenProtokoll.BeforeLoadDFMValues;
  try
    Name := 'frmDateien';
    Width := 222;
    Height := 310;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebImageControl1.SetParentComponent(Self);
    WebImageControl1.Name := 'WebImageControl1';
    WebImageControl1.Left := 120;
    WebImageControl1.Top := 227;
    WebImageControl1.Width := 68;
    WebImageControl1.Height := 41;
    WebImageControl1.HeightPercent := 100.000000000000000000;
    WebImageControl1.WidthPercent := 100.000000000000000000;
    WebImageControl1.ChildOrder := 7;
    Container1.SetParentComponent(Self);
    Container1.Name := 'Container1';
    Container1.Left := 0;
    Container1.Top := 0;
    Container1.Width := 169;
    Container1.Height := 41;
    Container1.ElementClassName := 'container-fluid rounded';
    Container1.HeightStyle := ssAuto;
    Container1.WidthStyle := ssPercent;
    Container1.ElementFont := efCSS;
    Container1.ElementPosition := epIgnore;
    Container2.SetParentComponent(Self);
    Container2.Name := 'Container2';
    Container2.Left := 0;
    Container2.Top := 47;
    Container2.Width := 169;
    Container2.Height := 41;
    Container2.ElementClassName := 'd-flex flex-wrap m-1';
    Container2.HeightStyle := ssAuto;
    Container2.WidthStyle := ssAuto;
    Container2.ChildOrder := 1;
    Container2.ElementFont := efCSS;
    Container2.ElementPosition := epIgnore;
    Container3.SetParentComponent(Self);
    Container3.Name := 'Container3';
    Container3.Left := 0;
    Container3.Top := 94;
    Container3.Width := 169;
    Container3.Height := 41;
    Container3.ElementClassName := 'd-flex flex-wrap m-1';
    Container3.HeightStyle := ssAuto;
    Container3.WidthStyle := ssAuto;
    Container3.ChildOrder := 2;
    Container3.ElementFont := efCSS;
    Container3.ElementPosition := epIgnore;
    btnzurueck.SetParentComponent(Self);
    btnzurueck.Name := 'btnzurueck';
    btnzurueck.Left := 64;
    btnzurueck.Top := 141;
    btnzurueck.Width := 110;
    btnzurueck.Height := 25;
    btnzurueck.Caption := '<< zur'#252'ck';
    btnzurueck.ChildOrder := 4;
    btnzurueck.ElementClassName := 'btn btn-info m-1 text-left';
    btnzurueck.ElementFont := efCSS;
    btnzurueck.ElementPosition := epIgnore;
    btnzurueck.HeightStyle := ssAuto;
    btnzurueck.HeightPercent := 100.000000000000000000;
    btnzurueck.WidthPercent := 100.000000000000000000;
    SetEvent(btnzurueck, Self, 'OnClick', 'btnzurueckClick');
    btnNeu.SetParentComponent(Self);
    btnNeu.Name := 'btnNeu';
    btnNeu.Left := 64;
    btnNeu.Top := 168;
    btnNeu.Width := 110;
    btnNeu.Height := 25;
    btnNeu.Caption := '+ Datei';
    btnNeu.ChildOrder := 4;
    btnNeu.ElementClassName := 'btn btn-info m-1 text-left';
    btnNeu.ElementFont := efCSS;
    btnNeu.ElementPosition := epIgnore;
    btnNeu.HeightStyle := ssAuto;
    btnNeu.HeightPercent := 100.000000000000000000;
    btnNeu.WidthPercent := 100.000000000000000000;
    SetEvent(btnNeu, Self, 'OnClick', 'btnNeuClick');
    btnFoto.SetParentComponent(Self);
    btnFoto.Name := 'btnFoto';
    btnFoto.Left := 64;
    btnFoto.Top := 196;
    btnFoto.Width := 110;
    btnFoto.Height := 25;
    btnFoto.Caption := '+ Foto';
    btnFoto.ChildOrder := 4;
    btnFoto.ElementClassName := 'btn btn-info m-1 text-left';
    btnFoto.ElementFont := efCSS;
    btnFoto.ElementPosition := epIgnore;
    btnFoto.HeightStyle := ssAuto;
    btnFoto.HeightPercent := 100.000000000000000000;
    btnFoto.WidthPercent := 100.000000000000000000;
    SetEvent(btnFoto, Self, 'OnClick', 'btnFotoClick');
    MSGLOESCHEN.SetParentComponent(Self);
    MSGLOESCHEN.Name := 'MSGLOESCHEN';
    MSGLOESCHEN.Left := 136;
    MSGLOESCHEN.Top := 286;
    MSGLOESCHEN.Width := 24;
    MSGLOESCHEN.Height := 24;
    MSGLOESCHEN.HeightStyle := ssAuto;
    MSGLOESCHEN.WidthStyle := ssAuto;
    MSGLOESCHEN.Buttons := [mbYes,mbNo];
    MSGLOESCHEN.DialogType := mtConfirmation;
    MSGLOESCHEN.Message := 'Das L'#246'schen einer Datei kann nicht r'#252'ckg'#228'ngig gemacht werden.Wollen Sie die Datei wirklich l'#246'schen?';
    MSGLOESCHEN.Opacity := 0.200000000000000000;
    MSGLOESCHEN.ElementButtonClassName := 'btn';
    MSGLOESCHEN.ElementDialogClassName := 'shadow-lg p-3 mb-5 bg-white rounded';
    MSGLOESCHEN.ElementTitleClassName := 'text-body';
    MSGLOESCHEN.ElementContentClassName := 'text-body';
    dsDateien.SetParentComponent(Self);
    dsDateien.Name := 'dsDateien';
    dsDateien.AfterApplyUpdates := dsDateienAfterApplyUpdates;
    dsDateien.AfterOpen := dsDateienAfterOpen;
    dsDateien.BeforeDelete := dsDateienBeforeDelete;
    dsDateien.AfterDelete := dsDateienAfterDelete;
    dsDateien.EntitySetName := 'DokumenteDateien';
    dsDateien.Connection := DM2.XDataWebConnection1;
    dsDateien.Left := 116;
    dsDateien.Top := 72;
    dsDateienID.SetParentComponent(dsDateien);
    dsDateienID.Name := 'dsDateienID';
    dsDateienID.FieldName := 'ID';
    dsDateienDatumUhrzeit.SetParentComponent(dsDateien);
    dsDateienDatumUhrzeit.Name := 'dsDateienDatumUhrzeit';
    dsDateienDatumUhrzeit.FieldName := 'DatumUhrzeit';
    dsDateienDateiMime.SetParentComponent(dsDateien);
    dsDateienDateiMime.Name := 'dsDateienDateiMime';
    dsDateienDateiMime.FieldName := 'DateiMime';
    dsDateienDateiMime.Size := 50;
    dsDateienDateiName.SetParentComponent(dsDateien);
    dsDateienDateiName.Name := 'dsDateienDateiName';
    dsDateienDateiName.FieldName := 'DateiName';
    dsDateienDateiName.Size := 255;
    dsDateienDateiGroesse.SetParentComponent(dsDateien);
    dsDateienDateiGroesse.Name := 'dsDateienDateiGroesse';
    dsDateienDateiGroesse.FieldName := 'DateiGroesse';
    dsDateienDateiInhaltThumb.SetParentComponent(dsDateien);
    dsDateienDateiInhaltThumb.Name := 'dsDateienDateiInhaltThumb';
    dsDateienDateiInhaltThumb.FieldName := 'DateiInhaltThumb';
    dsDateienDateiInhaltThumb.Size := 255;
    dsDateienProtokoll.SetParentComponent(dsDateien);
    dsDateienProtokoll.Name := 'dsDateienProtokoll';
    dsDateienProtokoll.FieldName := 'Protokoll';
    dsDateienProtokoll.Size := 255;
    dsDateienDateiBetreff.SetParentComponent(dsDateien);
    dsDateienDateiBetreff.Name := 'dsDateienDateiBetreff';
    dsDateienDateiBetreff.FieldName := 'DateiBetreff';
    dsDateienDateiBetreff.Size := 50;
    dsDateienKundennummer.SetParentComponent(dsDateien);
    dsDateienKundennummer.Name := 'dsDateienKundennummer';
    dsDateienKundennummer.FieldName := 'Kundennummer';
    dsDateienKundennummer.Size := 13;
    dsDateienNummerkomplett.SetParentComponent(dsDateien);
    dsDateienNummerkomplett.Name := 'dsDateienNummerkomplett';
    dsDateienNummerkomplett.FieldName := 'Nummerkomplett';
    dsDateienNummerkomplett.Size := 10;
    dsDateienObjektReferenz.SetParentComponent(dsDateien);
    dsDateienObjektReferenz.Name := 'dsDateienObjektReferenz';
    dsDateienObjektReferenz.FieldName := 'ObjektReferenz';
    dsDateienObjektReferenz.Size := 13;
    dsDateienFahrzeugID.SetParentComponent(dsDateien);
    dsDateienFahrzeugID.Name := 'dsDateienFahrzeugID';
    dsDateienFahrzeugID.FieldName := 'FahrzeugID';
    dsDateienAuslagerungsdatei.SetParentComponent(dsDateien);
    dsDateienAuslagerungsdatei.Name := 'dsDateienAuslagerungsdatei';
    dsDateienAuslagerungsdatei.FieldName := 'Auslagerungsdatei';
    sourceDateien.SetParentComponent(Self);
    sourceDateien.Name := 'sourceDateien';
    sourceDateien.DataSet := dsDateien;
    sourceDateien.Left := 32;
    sourceDateien.Top := 72;
    WClient.SetParentComponent(Self);
    WClient.Name := 'WClient';
    WClient.Connection := DM2.XDataWebConnection1;
    WClient.Left := 24;
    WClient.Top := 154;
    xdsProtokolleLoeschungen.SetParentComponent(Self);
    xdsProtokolleLoeschungen.Name := 'xdsProtokolleLoeschungen';
    xdsProtokolleLoeschungen.AfterPost := xdsProtokolleLoeschungenAfterPost;
    xdsProtokolleLoeschungen.EntitySetName := 'ProtokolleLoeschungen';
    xdsProtokolleLoeschungen.Connection := DM2.XDataWebConnection1;
    xdsProtokolleLoeschungen.QueryTop := 1;
    xdsProtokolleLoeschungen.Left := 80;
    xdsProtokolleLoeschungen.Top := 248;
    xdsProtokolleLoeschungenID.SetParentComponent(xdsProtokolleLoeschungen);
    xdsProtokolleLoeschungenID.Name := 'xdsProtokolleLoeschungenID';
    xdsProtokolleLoeschungenID.FieldName := 'ID';
    xdsProtokolleLoeschungenID.Size := 38;
    xdsProtokolleLoeschungenDatum.SetParentComponent(xdsProtokolleLoeschungen);
    xdsProtokolleLoeschungenDatum.Name := 'xdsProtokolleLoeschungenDatum';
    xdsProtokolleLoeschungenDatum.FieldName := 'Datum';
    xdsProtokolleLoeschungenBenutzer.SetParentComponent(xdsProtokolleLoeschungen);
    xdsProtokolleLoeschungenBenutzer.Name := 'xdsProtokolleLoeschungenBenutzer';
    xdsProtokolleLoeschungenBenutzer.FieldName := 'Benutzer';
    xdsProtokolleLoeschungenBenutzer.Size := 50;
    xdsProtokolleLoeschungenBelegart.SetParentComponent(xdsProtokolleLoeschungen);
    xdsProtokolleLoeschungenBelegart.Name := 'xdsProtokolleLoeschungenBelegart';
    xdsProtokolleLoeschungenBelegart.FieldName := 'Belegart';
    xdsProtokolleLoeschungenBelegart.Size := 50;
    xdsProtokolleLoeschungenBelegnummer.SetParentComponent(xdsProtokolleLoeschungen);
    xdsProtokolleLoeschungenBelegnummer.Name := 'xdsProtokolleLoeschungenBelegnummer';
    xdsProtokolleLoeschungenBelegnummer.FieldName := 'Belegnummer';
    xdsProtokolleLoeschungenBelegnummer.Size := 25;
    xdsProtokolleLoeschungenProtokoll.SetParentComponent(xdsProtokolleLoeschungen);
    xdsProtokolleLoeschungenProtokoll.Name := 'xdsProtokolleLoeschungenProtokoll';
    xdsProtokolleLoeschungenProtokoll.FieldName := 'Protokoll';
    xdsProtokolleLoeschungenProtokoll.Size := 255;
  finally
    WebImageControl1.AfterLoadDFMValues;
    Container1.AfterLoadDFMValues;
    Container2.AfterLoadDFMValues;
    Container3.AfterLoadDFMValues;
    btnzurueck.AfterLoadDFMValues;
    btnNeu.AfterLoadDFMValues;
    btnFoto.AfterLoadDFMValues;
    MSGLOESCHEN.AfterLoadDFMValues;
    dsDateien.AfterLoadDFMValues;
    dsDateienID.AfterLoadDFMValues;
    dsDateienDatumUhrzeit.AfterLoadDFMValues;
    dsDateienDateiMime.AfterLoadDFMValues;
    dsDateienDateiName.AfterLoadDFMValues;
    dsDateienDateiGroesse.AfterLoadDFMValues;
    dsDateienDateiInhaltThumb.AfterLoadDFMValues;
    dsDateienProtokoll.AfterLoadDFMValues;
    dsDateienDateiBetreff.AfterLoadDFMValues;
    dsDateienKundennummer.AfterLoadDFMValues;
    dsDateienNummerkomplett.AfterLoadDFMValues;
    dsDateienObjektReferenz.AfterLoadDFMValues;
    dsDateienFahrzeugID.AfterLoadDFMValues;
    dsDateienAuslagerungsdatei.AfterLoadDFMValues;
    sourceDateien.AfterLoadDFMValues;
    WClient.AfterLoadDFMValues;
    xdsProtokolleLoeschungen.AfterLoadDFMValues;
    xdsProtokolleLoeschungenID.AfterLoadDFMValues;
    xdsProtokolleLoeschungenDatum.AfterLoadDFMValues;
    xdsProtokolleLoeschungenBenutzer.AfterLoadDFMValues;
    xdsProtokolleLoeschungenBelegart.AfterLoadDFMValues;
    xdsProtokolleLoeschungenBelegnummer.AfterLoadDFMValues;
    xdsProtokolleLoeschungenProtokoll.AfterLoadDFMValues;
  end;
end;

end.
